<template>
    <div>
        <div>
            <el-form label-position="right" label-width="120px">
                <el-form-item label="序列号">
                    <el-input v-model="filter.serial_id" size="small"
                              placeholder="序列号" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="内部编号">
                    <el-input v-model="filter.sign" size="small"
                              placeholder="内部编号" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="来源">
                    <el-input v-model="filter.supplier" size="small"
                              placeholder="来源" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="所属">
                    <el-input v-model="filter.receiver" size="small"
                              placeholder="所属" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="仓库">
                    <el-select v-model="filter.store_id" placeholder="仓库"
                               clearable
                               filterable remote
                               style="width: 200px;"
                               :remote-method="handelSearchStore"
                               @change="handleChange">
                        <el-option
                                v-for="item in warehouses"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="filter.type" placeholder="类型"
                               style="width: 200px;"
                               clearable
                               disabled
                               filterable remote>
                        <el-option
                                v-for="item in types"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品种类">
                    <el-select v-model="filter.category_id" placeholder="商品种类"
                               style="width: 200px;"
                               clearable
                               filterable remote>
                        <el-option
                                v-for="item in categorys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="filter.description" size="small"
                              placeholder="描述" style="width: 200px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreShopName()"
                       :loading="button_loading">保存
            </el-button>
        </div>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "Dialogs_StoreShopMsg",
        data() {
            return {
                filter:{
                    id:'',
                    serial_id:'',
                    sign:'',
                    supplier:'',
                    receiver:'',
                    store_id:'',
                    type:'',
                    category_id:''
                },
                warehouses:[],
                types:[
                    {
                        id:1,
                        name:'出售'
                    },
                    {
                        id:2,
                        name:'出租'
                    }],
                categorys:[
                    {
                        id:1,
                        name:'平板'
                    },
                    {
                        id:2,
                        name:'笔'
                    }
                ],

                button_loading:false,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            if(this.$store.state.modal.data.shopMsg){
                this.filter.id=this.$store.state.modal.data.shopMsg.id;
                this.filter.serial_id=this.$store.state.modal.data.shopMsg.serial_id
                this.filter.sign=this.$store.state.modal.data.shopMsg.sign
                this.filter.supplier=this.$store.state.modal.data.shopMsg.supplier
                this.filter.receiver=this.$store.state.modal.data.shopMsg.receiver
                this.filter.store_id=this.$store.state.modal.data.shopMsg.store_id
                this.filter.type=this.$store.state.modal.data.shopMsg.type
                this.filter.category_id=this.$store.state.modal.data.shopMsg.category_id
            }
            this.handelSearchStore();
        },
        methods: {
            handleStoreShopName(){
                this.button_loading=true;
                this.$axios.post(store.state.server + '/createOrUpdateShop', {
                        'nameId':this.$store.state.modal.data.nameId,
                        'serialId':this.filter.serial_id,
                        'sign':this.filter.sign,
                        'supplier':this.filter.supplier,
                        'receiver':this.filter.receiver,
                        'storeId':this.filter.store_id,
                        'type':this.filter.type,
                        'categoryId':this.filter.category_id,
                        'shopId':this.filter.id,
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.button_loading=false;
                        this.$set(this.$parentInfo.shopMsgs,response.data.content.id.id,response.data.content.id)
                        this.$parentInfo.total++
                        this.$Win.closeModal()
                    }
                }).catch((res) => {
                    this.button_loading=false;
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchStore(val=''){
                this.$axios.get(store.state.server + '/searchByStoreName?storeName=' +val+'&type=').then((response) => {
                    if (response.data.code == '0000') {
                        this.warehouses=response.data.content.storeName
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleChange(){
                for(let i=0;i<this.warehouses.length;i++){
                    if(this.warehouses[i].id==this.filter.store_id){
                        this.filter.type=this.warehouses[i].type
                        break;
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>